import styled from "@emotion/styled";

import { DesignToken, RadiusToken, SpacingToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";
import { withPx, withVar } from "themes/helpers";

interface IContentBoxWrapper {
  withoutTitle?: boolean;
}

export const ContentBoxWrapper = styled.div<IContentBoxWrapper>`
  display: flex;
  overflow: auto;
  width: 100%;
  height: 100%;
  padding: ${(props): string => (props.withoutTitle ? "100px" : "40px")} 20px;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: center;
  background: ${withVar(DesignToken.SurfaceSecondaryDefault)};

  @media screen and (max-width: ${withPx(ResponsiveBreakpoint.Mobile)}) {
    padding: 0;
  }
`;

interface IContentBox {
  centered?: boolean;
}

export const ContentBox = styled.div<IContentBox>`
  box-sizing: border-box;
  width: 640px;
  padding: 40px 68px;

  ${(props): string => (props.centered ? "text-align: center" : "")};
  border: 1px solid var(${DesignToken.BorderBasicPrimary});
  border-radius: var(${RadiusToken.Radius3});
  background: var(${DesignToken.SurfacePrimaryDefault});
  color: var(${DesignToken.ContentBasicPrimary});

  @media (max-width: ${withPx(ResponsiveBreakpoint.Mobile)}) {
    width: 100%;
    border: 0;
    border-radius: 0;
    height: 100%;
  }

  textarea {
    font-size: 14px;
    width: 100%;
    height: 7.5em;
  }
`;

export const ButtonsWrapper = styled.div`
  margin-top: ${withVar(SpacingToken.Spacing7)};
`;

export const SideNoteWrapper = styled.div`
  margin: ${withVar(SpacingToken.Spacing5)} auto -15px;
  padding-top: ${withVar(SpacingToken.Spacing5)};
  border-top: 1px solid var(${DesignToken.BorderBasicPrimary});
`;
